import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  disabled: "disabled",
  class: "disabled-option"
}
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    class: "form-control",
    value: _ctx.store,
    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("option", null, null, -1)),
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("option", _hoisted_2, "読込中..."))
      : (_ctx.list.length === 0)
        ? (_openBlock(), _createElementBlock("option", _hoisted_3, "データが未登録です"))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.id,
              value: item.id
            }, _toDisplayString(item.text), 9, _hoisted_4))
          }), 128))
  ], 40, _hoisted_1))
}